module.exports = __webpack_public_path__ + "4381f16e733ba66fdb84eca3c4a1d448.png";